import { Box, BoxProps, Button, Input, InputGroup, InputProps, InputRightElement, SelectProps } from "@chakra-ui/react";
import { CoinSelect } from "components/Select/CoinSelect";
// import { Select } from "components/Select/Select";
// import SelectWithImage from "components/Select/SelectWithImage";
import { PropsWithChildren } from "react";
import { when } from "utils";

interface CryptoTxProps extends InputProps {
  onMax?: () => void;
  isLoading?: boolean;
  coinValue?: string;
  onCoinChange?: (coin: string, network?: string) => void;
  _rightEl?: BoxProps;
  _select?: SelectProps;
  walletType: string[];
  shouldOpen?: boolean;
  disableSelect?: boolean;
  selectTitle?: string;
  network?: string;
  isNetworkRequired?: boolean;
}

export default function CrytpoTxInput(props: PropsWithChildren<CryptoTxProps>) {
  const {
    network,
    selectTitle,
    children,
    coinValue,
    isLoading,
    onMax,
    onCoinChange,
    _rightEl,
    _select,
    isNetworkRequired,
    walletType,
    shouldOpen,
    disableSelect,
    ...xprops
  } = props;

  // const pr = when(!!onMax, "66px", "48px");
  const spr = when(!!children, "180px", "48px");
  const mpr = when(!!onMax, "66px", "48px");
  const pr = when(!!onMax && !!children, spr, mpr);

  const mr = when(!!children, "118px", "18px");

  const handleCoinChange = (coin: string, network?: string) => {
    !!onCoinChange && onCoinChange(coin, network);
  };

  return (
    <Box pos="relative">
      <InputGroup isolation="auto">
        {/* <InputLeftElement h="100%" left="0px" children={<CoinIcon coin="ngn" boxSize="24px" />} {..._leftEl} /> */}

        <Input pr={pr} w="100%" type="number" {...xprops} />

        {onMax && (
          <InputRightElement
            h="100%"
            w="fit-content"
            right={mr}
            children={
              <Button w="48px" variant="max" onClick={onMax} isLoading={isLoading} disabled={isLoading}>
                Max
              </Button>
            }
            {..._rightEl}
          />
        )}

        {/* <InputRightElement
          zIndex="auto"
          h="100%"
          top="-2px"
          w="fit-content"
          right="18px"
          children={
            children && (
              <SelectWithImage
                coinSelected={coinValue!}
                onChange={handleCoinChange}
                handleMenuItem={handleCoinChange}
                wallet={walletType!}
                shouldOpen={shouldOpen}
              />
            )
          }
        /> */}
        <InputRightElement
          zIndex="auto"
          h="100%"
          top="-2px"
          w="fit-content"
          right="18px"
          children={
            children && (
              <CoinSelect
                coin={coinValue!}
                tokens={walletType!}
                title={selectTitle}
                onSelect={handleCoinChange}
                fontSize="sm"
                network={network}
                isNetworkRequired={isNetworkRequired}
                _label={{ fontWeight: "600", fontSize: "sm" }}
                disableSelect={disableSelect}
              />
            )
          }
        />
        {/* <InputRightElement
          h="100%"
          top="-2px"
          w="fit-content"
          right="18px"
          children={
            children && (
              <CSelect value={coinValue ?? ""} onChange={handleCoinChange} {..._select}>
                {children}
              </CSelect>
            )
          }
        /> */}
      </InputGroup>
    </Box>
  );
}
